<template>
    <div>
        <li class="m_li" id="rhist" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <a href="javascript:;" class="f">
                <i class="iconfont icon-shouye" style="color:#ffffff;font-size:22px;"></i>
            </a>
            <div class="r_av m_tr" id="ghis" :style="active">
                <em class="r_vt">◆</em>
                <h4>浏览历史</h4>
                <div id="hibx">
                    <a href="javascript:;" class="hs_ra" title="雅迪克 植物提取男用抑菌喷剂10ml">
                        <img src="https://s.cccgx.com/t/60x60/images/202006/source_img/m14091_P_1592363659338.jpg" width="60" height="60">
                        <p>¥198.00</p>
                    </a>
                    <a href="javascript:;" class="hs_ra" title="夜樱 魔法AV震动按摩自慰棒">
                        <img src="https://s.cccgx.com/t/60x60/images/qu/17231/gallery/m20201208091308_59263.jpg" width="60" height="60">
                        <p>¥239.00</p>
                    </a>
                    <a href="javascript:;" class="hs_ra" title="瑰若 性感紧身包臀秘书OL教师套装">
                        <img src="https://s.cccgx.com/t/60x60/images/201910/source_img/15651_P_1572242224026.jpg" width="60" height="60">
                        <p>¥79.00</p>
                    </a>
                    <a href="javascript:;" class="hs_ra" title="雷霆leten 波多野结衣签名倒模原声飞机杯">
                        <img src="https://s.cccgx.com/t/60x60/images/qu/12471/gallery/m20210302063232_94257.jpg" width="60" height="60">
                        <p>¥435.00</p>
                    </a>
                    <a href="javascript:;" class="hs_ra" title="雷霆708 未来舱全自动伸缩发音烘干飞机杯 定制款/PRO款">
                        <img src="https://s.cccgx.com/t/60x60/images/qu/15151/gallery/m20210107035233_12264.jpg" width="60" height="60">
                        <p>¥898.00</p>
                    </a>
                    <a href="javascript:;" class="hs_ra" title="COC 雏菊 震动无线遥控阴乳挑逗跳蛋">
                        <img src="https://s.cccgx.com/t/60x60/images/qu/16126/gallery/m20201201131503_58226.jpg" width="60" height="60">
                        <p>¥186.00</p>
                    </a>
                </div>
            </div>
        </li>
    </div>
</template>

<script>
export default{
    data(){
        return{
            active:"",
        }
    },
    methods:{
        onMouseOver($event){
            $event.currentTarget.className="m_li m_lion";
            this.active="opacity: 1; right: 35px; display: block;"
        },
        onMouseOut($event){
            $event.currentTarget.className="m_li";
            this.active="opacity: 0; right: 70px; display: none;"
        },
    },
}
</script>

<style scoped>
.active{display: none;}
</style>



// WEBPACK FOOTER //
// src/components/common/right-history.vue